import React, {useEffect, useState, useRef} from 'react';
//components
import View from './show-member-view';
//utils
import {OrganisationService} from '../../../utils/data-transfer';
//routing
import {withRouter} from 'react-router-dom';

const ShowMemberContainer = (props) => {
  const organisationService = useRef(new OrganisationService())
  const {match, history} = props;
  const [state, setState] = useState({
    member: null,
    isModified: false,
    isLoading: true,
    memberTypes: [],
    events: [],
    pastEvents: [],
    meetings: [],
    pastMeetings: [],
  });

  useEffect(() => {
    const bootstrapComponent = async () => {
      try {
        const resp = await Promise.all([
          await organisationService.current.getMember(match.params.organisationMemberId),
          await organisationService.current.getMemberEvents(match.params.organisationMemberId, false),
          await organisationService.current.getMemberEvents(match.params.organisationMemberId, true),
          await organisationService.current.getMemberMeetings(match.params.organisationMemberId, false),
          await organisationService.current.getMemberMeetings(match.params.organisationMemberId, true),
        ]);

        setState(prevState => ({...prevState, member: resp[0], events: resp[1], pastEvents: resp[2], meetings: resp[3], pastMeetings: resp[4], isLoading: false}));
      } catch (ex) {

        console.log(ex);
        history.push('/error?errorMessage=An unexpected error occurred when trying to view a Member.\nPlease try again shortly.\nIf this error persists please Contact Us.');
      }
    };

    bootstrapComponent();
  }, []);

  useEffect(() => {
    if(state.isModified) {
      const _organisationService = new OrganisationService()
      _organisationService.setMember(state.member);
      setState(prevState => ({...prevState, isModified: false}));
    }
  }, [state.isModified]);

  const updateMemberDescription = (d) => {
    setState(prevState => ({...prevState, isModified: true, member: Object.assign({}, state.member, { profileDescription: d })}));
  };

  return (
    <View
      {...state} updateMemberDescription={updateMemberDescription}/>
  );
}

export default withRouter(ShowMemberContainer);
